// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as LeadershipIndexRouteImport } from './routes/leadership.index'
import { Route as InsightsIndexRouteImport } from './routes/insights.index'
import { Route as ClientStoriesIndexRouteImport } from './routes/client-stories.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as NewsletterUnsubscribeRouteImport } from './routes/newsletter/unsubscribe'
import { Route as LeadershipSlugRouteImport } from './routes/leadership.$slug'
import { Route as InsightsSlugRouteImport } from './routes/insights.$slug'
import { Route as ClientStoriesSlugRouteImport } from './routes/client-stories.$slug'
import { Route as CareersSlugRouteImport } from './routes/careers.$slug'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminPagesRouteRouteImport } from './routes/admin/pages/route'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminStoriesIndexRouteImport } from './routes/admin/stories/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminServicesIndexRouteImport } from './routes/admin/services/index'
import { Route as AdminProfileIndexRouteImport } from './routes/admin/profile/index'
import { Route as AdminMenusIndexRouteImport } from './routes/admin/menus/index'
import { Route as AdminMediaIndexRouteImport } from './routes/admin/media/index'
import { Route as AdminLegalIndexRouteImport } from './routes/admin/legal/index'
import { Route as AdminLeadersIndexRouteImport } from './routes/admin/leaders/index'
import { Route as AdminInsightsIndexRouteImport } from './routes/admin/insights/index'
import { Route as AdminContactsIndexRouteImport } from './routes/admin/contacts/index'
import { Route as AdminCareersIndexRouteImport } from './routes/admin/careers/index'
import { Route as AdminUsersNewRouteImport } from './routes/admin/users/new'
import { Route as AdminStoriesNewRouteImport } from './routes/admin/stories/new'
import { Route as AdminStoriesIdRouteImport } from './routes/admin/stories/$id'
import { Route as AdminServicesNewRouteImport } from './routes/admin/services/new'
import { Route as AdminServicesIdRouteImport } from './routes/admin/services/$id'
import { Route as AdminLegalSlugRouteImport } from './routes/admin/legal/$slug'
import { Route as AdminLeadersNewRouteImport } from './routes/admin/leaders/new'
import { Route as AdminLeadersIdRouteImport } from './routes/admin/leaders/$id'
import { Route as AdminInsightsNewRouteImport } from './routes/admin/insights/new'
import { Route as AdminInsightsIdRouteImport } from './routes/admin/insights/$id'
import { Route as AdminCareersNewRouteImport } from './routes/admin/careers/new'
import { Route as AdminCareersIdRouteImport } from './routes/admin/careers/$id'
import { Route as AdminNewsletterNewslettersRouteRouteImport } from './routes/admin/newsletter/newsletters/route'
import { Route as AdminPagesIndexRouteImport } from './routes/admin/pages/index'
import { Route as AdminPagesNewRouteImport } from './routes/admin/pages/new'
import { Route as AdminPagesIdRouteImport } from './routes/admin/pages/$id'
import { Route as AdminNewsletterSubscribersIndexRouteImport } from './routes/admin/newsletter/subscribers/index'
import { Route as AdminMarketingWhoWeServeIndexRouteImport } from './routes/admin/marketing/who-we-serve/index'
import { Route as AdminMarketingTestimonialsIndexRouteImport } from './routes/admin/marketing/testimonials/index'
import { Route as AdminInsightsTagsIndexRouteImport } from './routes/admin/insights/tags/index'
import { Route as AdminInsightsNewslettersIndexRouteImport } from './routes/admin/insights/newsletters/index'
import { Route as AdminInsightsFormsIndexRouteImport } from './routes/admin/insights/forms/index'
import { Route as AdminMarketingWhoWeServeNewRouteImport } from './routes/admin/marketing/who-we-serve/new'
import { Route as AdminMarketingWhoWeServeIdRouteImport } from './routes/admin/marketing/who-we-serve/$id'
import { Route as AdminMarketingTestimonialsNewRouteImport } from './routes/admin/marketing/testimonials/new'
import { Route as AdminMarketingTestimonialsIdRouteImport } from './routes/admin/marketing/testimonials/$id'
import { Route as AdminInsightsTagsNewRouteImport } from './routes/admin/insights/tags/new'
import { Route as AdminInsightsTagsIdRouteImport } from './routes/admin/insights/tags/$id'
import { Route as AdminInsightsNewslettersNewRouteImport } from './routes/admin/insights/newsletters/new'
import { Route as AdminInsightsNewslettersIdRouteImport } from './routes/admin/insights/newsletters/$id'
import { Route as AdminNewsletterNewslettersIndexRouteImport } from './routes/admin/newsletter/newsletters/index'
import { Route as AdminNewsletterNewslettersNewRouteImport } from './routes/admin/newsletter/newsletters/new'
import { Route as AdminNewsletterNewslettersIdRouteImport } from './routes/admin/newsletter/newsletters/$id'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const LeadershipIndexRoute = LeadershipIndexRouteImport.update({
            id: '/leadership/',path: '/leadership/',getParentRoute: () => rootRouteImport
          })
const InsightsIndexRoute = InsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => rootRouteImport
          })
const ClientStoriesIndexRoute = ClientStoriesIndexRouteImport.update({
            id: '/client-stories/',path: '/client-stories/',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const NewsletterUnsubscribeRoute = NewsletterUnsubscribeRouteImport.update({
            id: '/newsletter/unsubscribe',path: '/newsletter/unsubscribe',getParentRoute: () => rootRouteImport
          })
const LeadershipSlugRoute = LeadershipSlugRouteImport.update({
            id: '/leadership/$slug',path: '/leadership/$slug',getParentRoute: () => rootRouteImport
          })
const InsightsSlugRoute = InsightsSlugRouteImport.update({
            id: '/insights/$slug',path: '/insights/$slug',getParentRoute: () => rootRouteImport
          })
const ClientStoriesSlugRoute = ClientStoriesSlugRouteImport.update({
            id: '/client-stories/$slug',path: '/client-stories/$slug',getParentRoute: () => rootRouteImport
          })
const CareersSlugRoute = CareersSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CareersRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AdminRouteRoute
          })
const AdminPagesRouteRoute = AdminPagesRouteRouteImport.update({
            id: '/pages',path: '/pages',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AdminRouteRoute
          })
const AdminStoriesIndexRoute = AdminStoriesIndexRouteImport.update({
            id: '/stories/',path: '/stories/',getParentRoute: () => AdminRouteRoute
          })
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => AdminRouteRoute
          })
const AdminServicesIndexRoute = AdminServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => AdminRouteRoute
          })
const AdminProfileIndexRoute = AdminProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => AdminRouteRoute
          })
const AdminMenusIndexRoute = AdminMenusIndexRouteImport.update({
            id: '/menus/',path: '/menus/',getParentRoute: () => AdminRouteRoute
          })
const AdminMediaIndexRoute = AdminMediaIndexRouteImport.update({
            id: '/media/',path: '/media/',getParentRoute: () => AdminRouteRoute
          })
const AdminLegalIndexRoute = AdminLegalIndexRouteImport.update({
            id: '/legal/',path: '/legal/',getParentRoute: () => AdminRouteRoute
          })
const AdminLeadersIndexRoute = AdminLeadersIndexRouteImport.update({
            id: '/leaders/',path: '/leaders/',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsIndexRoute = AdminInsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => AdminRouteRoute
          })
const AdminContactsIndexRoute = AdminContactsIndexRouteImport.update({
            id: '/contacts/',path: '/contacts/',getParentRoute: () => AdminRouteRoute
          })
const AdminCareersIndexRoute = AdminCareersIndexRouteImport.update({
            id: '/careers/',path: '/careers/',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersNewRoute = AdminUsersNewRouteImport.update({
            id: '/users/new',path: '/users/new',getParentRoute: () => AdminRouteRoute
          })
const AdminStoriesNewRoute = AdminStoriesNewRouteImport.update({
            id: '/stories/new',path: '/stories/new',getParentRoute: () => AdminRouteRoute
          })
const AdminStoriesIdRoute = AdminStoriesIdRouteImport.update({
            id: '/stories/$id',path: '/stories/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminServicesNewRoute = AdminServicesNewRouteImport.update({
            id: '/services/new',path: '/services/new',getParentRoute: () => AdminRouteRoute
          })
const AdminServicesIdRoute = AdminServicesIdRouteImport.update({
            id: '/services/$id',path: '/services/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminLegalSlugRoute = AdminLegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => AdminRouteRoute
          })
const AdminLeadersNewRoute = AdminLeadersNewRouteImport.update({
            id: '/leaders/new',path: '/leaders/new',getParentRoute: () => AdminRouteRoute
          })
const AdminLeadersIdRoute = AdminLeadersIdRouteImport.update({
            id: '/leaders/$id',path: '/leaders/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsNewRoute = AdminInsightsNewRouteImport.update({
            id: '/insights/new',path: '/insights/new',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsIdRoute = AdminInsightsIdRouteImport.update({
            id: '/insights/$id',path: '/insights/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminCareersNewRoute = AdminCareersNewRouteImport.update({
            id: '/careers/new',path: '/careers/new',getParentRoute: () => AdminRouteRoute
          })
const AdminCareersIdRoute = AdminCareersIdRouteImport.update({
            id: '/careers/$id',path: '/careers/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminNewsletterNewslettersRouteRoute = AdminNewsletterNewslettersRouteRouteImport.update({
            id: '/newsletter/newsletters',path: '/newsletter/newsletters',getParentRoute: () => AdminRouteRoute
          })
const AdminPagesIndexRoute = AdminPagesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminPagesRouteRoute
          })
const AdminPagesNewRoute = AdminPagesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminPagesRouteRoute
          })
const AdminPagesIdRoute = AdminPagesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminPagesRouteRoute
          })
const AdminNewsletterSubscribersIndexRoute = AdminNewsletterSubscribersIndexRouteImport.update({
            id: '/newsletter/subscribers/',path: '/newsletter/subscribers/',getParentRoute: () => AdminRouteRoute
          })
const AdminMarketingWhoWeServeIndexRoute = AdminMarketingWhoWeServeIndexRouteImport.update({
            id: '/marketing/who-we-serve/',path: '/marketing/who-we-serve/',getParentRoute: () => AdminRouteRoute
          })
const AdminMarketingTestimonialsIndexRoute = AdminMarketingTestimonialsIndexRouteImport.update({
            id: '/marketing/testimonials/',path: '/marketing/testimonials/',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsTagsIndexRoute = AdminInsightsTagsIndexRouteImport.update({
            id: '/insights/tags/',path: '/insights/tags/',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsNewslettersIndexRoute = AdminInsightsNewslettersIndexRouteImport.update({
            id: '/insights/newsletters/',path: '/insights/newsletters/',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsFormsIndexRoute = AdminInsightsFormsIndexRouteImport.update({
            id: '/insights/forms/',path: '/insights/forms/',getParentRoute: () => AdminRouteRoute
          })
const AdminMarketingWhoWeServeNewRoute = AdminMarketingWhoWeServeNewRouteImport.update({
            id: '/marketing/who-we-serve/new',path: '/marketing/who-we-serve/new',getParentRoute: () => AdminRouteRoute
          })
const AdminMarketingWhoWeServeIdRoute = AdminMarketingWhoWeServeIdRouteImport.update({
            id: '/marketing/who-we-serve/$id',path: '/marketing/who-we-serve/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminMarketingTestimonialsNewRoute = AdminMarketingTestimonialsNewRouteImport.update({
            id: '/marketing/testimonials/new',path: '/marketing/testimonials/new',getParentRoute: () => AdminRouteRoute
          })
const AdminMarketingTestimonialsIdRoute = AdminMarketingTestimonialsIdRouteImport.update({
            id: '/marketing/testimonials/$id',path: '/marketing/testimonials/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsTagsNewRoute = AdminInsightsTagsNewRouteImport.update({
            id: '/insights/tags/new',path: '/insights/tags/new',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsTagsIdRoute = AdminInsightsTagsIdRouteImport.update({
            id: '/insights/tags/$id',path: '/insights/tags/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsNewslettersNewRoute = AdminInsightsNewslettersNewRouteImport.update({
            id: '/insights/newsletters/new',path: '/insights/newsletters/new',getParentRoute: () => AdminRouteRoute
          })
const AdminInsightsNewslettersIdRoute = AdminInsightsNewslettersIdRouteImport.update({
            id: '/insights/newsletters/$id',path: '/insights/newsletters/$id',getParentRoute: () => AdminRouteRoute
          })
const AdminNewsletterNewslettersIndexRoute = AdminNewsletterNewslettersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminNewsletterNewslettersRouteRoute
          })
const AdminNewsletterNewslettersNewRoute = AdminNewsletterNewslettersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminNewsletterNewslettersRouteRoute
          })
const AdminNewsletterNewslettersIdRoute = AdminNewsletterNewslettersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminNewsletterNewslettersRouteRoute
          })





const AdminPagesRouteRouteChildren = {
  AdminPagesIdRoute: AdminPagesIdRoute,AdminPagesNewRoute: AdminPagesNewRoute,AdminPagesIndexRoute: AdminPagesIndexRoute
}

const AdminPagesRouteRouteWithChildren = AdminPagesRouteRoute._addFileChildren(AdminPagesRouteRouteChildren)




const AdminNewsletterNewslettersRouteRouteChildren = {
  AdminNewsletterNewslettersIdRoute: AdminNewsletterNewslettersIdRoute,AdminNewsletterNewslettersNewRoute: AdminNewsletterNewslettersNewRoute,AdminNewsletterNewslettersIndexRoute: AdminNewsletterNewslettersIndexRoute
}

const AdminNewsletterNewslettersRouteRouteWithChildren = AdminNewsletterNewslettersRouteRoute._addFileChildren(AdminNewsletterNewslettersRouteRouteChildren)



const AdminRouteRouteChildren = {
  AdminPagesRouteRoute: AdminPagesRouteRouteWithChildren,AdminLoginRoute: AdminLoginRoute,AdminIndexRoute: AdminIndexRoute,AdminNewsletterNewslettersRouteRoute: AdminNewsletterNewslettersRouteRouteWithChildren,AdminCareersIdRoute: AdminCareersIdRoute,AdminCareersNewRoute: AdminCareersNewRoute,AdminInsightsIdRoute: AdminInsightsIdRoute,AdminInsightsNewRoute: AdminInsightsNewRoute,AdminLeadersIdRoute: AdminLeadersIdRoute,AdminLeadersNewRoute: AdminLeadersNewRoute,AdminLegalSlugRoute: AdminLegalSlugRoute,AdminServicesIdRoute: AdminServicesIdRoute,AdminServicesNewRoute: AdminServicesNewRoute,AdminStoriesIdRoute: AdminStoriesIdRoute,AdminStoriesNewRoute: AdminStoriesNewRoute,AdminUsersNewRoute: AdminUsersNewRoute,AdminCareersIndexRoute: AdminCareersIndexRoute,AdminContactsIndexRoute: AdminContactsIndexRoute,AdminInsightsIndexRoute: AdminInsightsIndexRoute,AdminLeadersIndexRoute: AdminLeadersIndexRoute,AdminLegalIndexRoute: AdminLegalIndexRoute,AdminMediaIndexRoute: AdminMediaIndexRoute,AdminMenusIndexRoute: AdminMenusIndexRoute,AdminProfileIndexRoute: AdminProfileIndexRoute,AdminServicesIndexRoute: AdminServicesIndexRoute,AdminSettingsIndexRoute: AdminSettingsIndexRoute,AdminStoriesIndexRoute: AdminStoriesIndexRoute,AdminUsersIndexRoute: AdminUsersIndexRoute,AdminInsightsNewslettersIdRoute: AdminInsightsNewslettersIdRoute,AdminInsightsNewslettersNewRoute: AdminInsightsNewslettersNewRoute,AdminInsightsTagsIdRoute: AdminInsightsTagsIdRoute,AdminInsightsTagsNewRoute: AdminInsightsTagsNewRoute,AdminMarketingTestimonialsIdRoute: AdminMarketingTestimonialsIdRoute,AdminMarketingTestimonialsNewRoute: AdminMarketingTestimonialsNewRoute,AdminMarketingWhoWeServeIdRoute: AdminMarketingWhoWeServeIdRoute,AdminMarketingWhoWeServeNewRoute: AdminMarketingWhoWeServeNewRoute,AdminInsightsFormsIndexRoute: AdminInsightsFormsIndexRoute,AdminInsightsNewslettersIndexRoute: AdminInsightsNewslettersIndexRoute,AdminInsightsTagsIndexRoute: AdminInsightsTagsIndexRoute,AdminMarketingTestimonialsIndexRoute: AdminMarketingTestimonialsIndexRoute,AdminMarketingWhoWeServeIndexRoute: AdminMarketingWhoWeServeIndexRoute,AdminNewsletterSubscribersIndexRoute: AdminNewsletterSubscribersIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)




const CareersRouteChildren = {
  CareersSlugRoute: CareersSlugRoute
}

const CareersRouteWithChildren = CareersRoute._addFileChildren(CareersRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRouteRoute: AdminRouteRouteWithChildren,AboutRoute: AboutRoute,CareersRoute: CareersRouteWithChildren,ContactRoute: ContactRoute,IndustriesRoute: IndustriesRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,ClientStoriesSlugRoute: ClientStoriesSlugRoute,InsightsSlugRoute: InsightsSlugRoute,LeadershipSlugRoute: LeadershipSlugRoute,NewsletterUnsubscribeRoute: NewsletterUnsubscribeRoute,PSlugRoute: PSlugRoute,ServicesSlugRoute: ServicesSlugRoute,ClientStoriesIndexRoute: ClientStoriesIndexRoute,InsightsIndexRoute: InsightsIndexRoute,LeadershipIndexRoute: LeadershipIndexRoute,ServicesIndexRoute: ServicesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)